import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.99984 4.16699C10.4601 4.16699 10.8332 4.54009 10.8332 5.00033V9.16699H14.9998C15.4601 9.16699 15.8332 9.54009 15.8332 10.0003C15.8332 10.4606 15.4601 10.8337 14.9998 10.8337H10.8332V15.0003C10.8332 15.4606 10.4601 15.8337 9.99984 15.8337C9.5396 15.8337 9.1665 15.4606 9.1665 15.0003V10.8337H4.99984C4.5396 10.8337 4.1665 10.4606 4.1665 10.0003C4.1665 9.54009 4.5396 9.16699 4.99984 9.16699H9.1665V5.00033C9.1665 4.54009 9.5396 4.16699 9.99984 4.16699Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}